import type { ReportData, SlipPdfData } from '@quickreport/pdf';
import type { PdfRequest, PdfResponse } from './pdf.worker';

let worker: Worker | undefined;
let seq = 0;
const pending = new Map<number, (r: PdfResponse) => void>();

function getWorker(): Worker {
  if (worker) return worker;
  worker = new Worker(new URL('./pdf.worker.ts', import.meta.url), { type: 'module' });
  worker.onmessage = (e: MessageEvent<PdfResponse>) => {
    pending.get(e.data.id)?.(e.data);
    pending.delete(e.data.id);
  };
  return worker;
}

/** Render a report to PDF in the browser with the same engine and fonts as the server. */
export function renderPdf(
  data: ReportData,
  assets: Record<string, Uint8Array> = {},
): Promise<PdfResponse> {
  const id = ++seq;
  return new Promise((resolve) => {
    pending.set(id, resolve);
    const req: PdfRequest = { id, data, assets };
    getWorker().postMessage(req);
  });
}

/** Render the counter slip with the same engine and fonts. */
export function renderSlipPdf(
  data: SlipPdfData,
  assets: Record<string, Uint8Array> = {},
): Promise<PdfResponse> {
  const id = ++seq;
  return new Promise((resolve) => {
    pending.set(id, resolve);
    const req: PdfRequest = { id, kind: 'slip', data, assets };
    getWorker().postMessage(req);
  });
}
